<nav *ngIf="node?.children?.length">
  <ul class="first-level">
    <li *ngFor="let firstLevel of node?.children">
      <nav-label [node]="firstLevel" classContainer="label-first-level"></nav-label>

      @if (qtyLevels(firstLevel) === 4) {
        <content-4-levels [node]="firstLevel"></content-4-levels>
      }

      @if (qtyLevels(firstLevel) === 3) {
        <content-3-levels [node]="firstLevel"></content-3-levels>
      }

      @if (qtyLevels(firstLevel) === 2) {
        <content-2-levels [node]="firstLevel"></content-2-levels>
      }
    </li>
  </ul>
</nav>
